// https://github.com/nezhar/snypy-frontend

import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class LoadingScreenService {
	private _loading: boolean = false;
	private isFileUpload: boolean = false; // Flag to control file upload scenario
	loadingStatus: Subject<boolean> = new Subject();

	get loading(): boolean {
		return this._loading;
	}

	set loading(value: boolean) {
		// Only allow loading if not a file upload
		if (!this.isFileUpload) {
			this._loading = value;
			this.loadingStatus.next(value);
		}
	}

	// Control general loading
	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	// Disable loading screen for file upload
	disableLoadingForFileUpload() {
		this.isFileUpload = true;
	}

	// Re-enable loading screen after file upload completes
	enableLoadingForFileUpload() {
		this.isFileUpload = false;
	}
}
